import { render, staticRenderFns } from "./ui-drop-down-component.vue?vue&type=template&id=58030f3a&scoped=true&"
import script from "./ui-drop-down-component.vue?vue&type=script&lang=ts&"
export * from "./ui-drop-down-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-drop-down-component.vue?vue&type=style&index=0&id=58030f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58030f3a",
  null
  
)

export default component.exports